import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "knowledge-base",
  "use": "knowledge-base-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"knowledge-base\"><path fill-rule=\"evenodd\" d=\"M5 19h2v-2H5v2ZM5 7h2V5H5v2Zm0 6h2v-2H5v2ZM3 5h2V4a2 2 0 0 1 2-2h6v7l2.5-1.5L18 9V2h1c1.05 0 2 .95 2 2v16c0 1.05-.95 2-2 2H7c-1.05 0-2-.95-2-2v-1H3v-2h2v-4H3v-2h2V7H3V5Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol